module.exports = __webpack_public_path__ + "img/istay-white.4560856e.png";